import React, { useState } from "react";
import {
  IconButton,
  Popover,
  Box,
  TextField,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { cilCalendar } from "@coreui/icons";
import { CIcon } from "@coreui/icons-react/";

const DateFilterControl = ({ onApplyFilter }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("single"); // 'single' or 'range'
  const [singleDate, setSingleDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApply = () => {
    // Pass data back to parent
    if (filterType === "single") {
      onApplyFilter({ type: "single", date: singleDate });
    } else {
      onApplyFilter({ type: "range", startDate, endDate });
    }
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <div className="date-filter-wrapper" style={{ marginLeft: "10px" }}>
      <IconButton
        onClick={handleClick}
        sx={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "8px",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
        <CIcon icon={cilCalendar} size="lg" style={{ color: "white" }} />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ p: 2, width: "300px" }}>
          <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: "bold" }}>
            Filter Date
          </Typography>

          <ToggleButtonGroup
            color="primary"
            value={filterType}
            exclusive
            onChange={(e, newType) => {
              if (newType !== null) setFilterType(newType);
            }}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          >
            <ToggleButton value="single">Single Day</ToggleButton>
            <ToggleButton value="range">Date Range</ToggleButton>
          </ToggleButtonGroup>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {filterType === "single" ? (
              <TextField
                type="date"
                label="Select Date"
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
                value={singleDate}
                onChange={(e) => setSingleDate(e.target.value)}
              />
            ) : (
              <>
                <TextField
                  type="date"
                  label="Start Date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <TextField
                  type="date"
                  label="End Date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </>
            )}

            <Button
              variant="contained"
              onClick={handleApply}
              sx={{
                backgroundColor: "#642D92",
                "&:hover": { backgroundColor: "#4a216d" },
                mt: 1,
              }}
            >
              Apply Filter
            </Button>
          </Box>
        </Box>
      </Popover>
    </div>
  );
};

export default DateFilterControl;